/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const RunPipelineButtonText = styled.div({
  fontWeight: token('font.weight.regular'),
});
